import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Collapse as BaseCollapse } from 'reactstrap';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';

const Collapse = ({
  isOpen,
  setIsOpen,
  titleId,
  children,
  showDeleteButton,
  removeOrderCondition,
  hideBottomDivider,
}) => {
  return (
    <div className="vx-collapse mt-1" data-testd="testCollapse">
      <div
        className="lead collapse-title collapsed"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="d-flex justify-content-between">
          <span className="font-medium-1 font-weight-bolder">
            <FormattedMessage id={titleId} />
          </span>
          <span>
            {showDeleteButton && (
              <Icon.Trash2
                onClick={removeOrderCondition}
                className="mr-1"
                size={20}
              />
            )}
            {!isOpen ? (
              <Icon.PlusCircle size={20} data-testid="collapsePlus" />
            ) : (
              <Icon.MinusCircle size={20} />
            )}
          </span>
        </div>
        {!hideBottomDivider && <hr className="mb-2 mt-50" />}
      </div>
      <BaseCollapse isOpen={isOpen}>{children}</BaseCollapse>
    </div>
  );
};

Collapse.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
  titleId: PropTypes.string,
  children: PropTypes.any,
};

export default Collapse;
